// src/routes.js
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Login from './components/Login';
import PhotoProcessingPage from './pages/PhotoProcessingPage';
import ProcessingResultsPage from './pages/ProcessingResultsPage';
import NotFoundPage from './pages/NotFoundPage';
import JobsPage from './pages/JobsPage';
import ExperimentPage from './pages/ExperimentPage';
import ExperimentsPage from './pages/ExperimentsPage';
import GroupsPage from './pages/GroupsPage';
import MyGroupsPage from './pages/MyGroupsPage';
import CreateGroupPage from './pages/CreateGroupPage';
import GroupDetailPage from './pages/GroupDetailPage';
import UserProfilePage from './pages/UserProfilePage';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './contexts/AuthContext';

const AppRoutes = () => {
  const { isAuthenticated, login } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={!isAuthenticated ? <Login onLogin={login} /> : <Navigate to="/jobs" />}
      />
      <Route
        path="/login"
        element={!isAuthenticated ? <Login onLogin={login} /> : <Navigate to="/jobs" />}
      />

      {/* Existing routes */}
      <Route path="/photo-processing" element={<ProtectedRoute><PhotoProcessingPage /></ProtectedRoute>} />
      <Route path="/processing-results/:jobId" element={<ProtectedRoute><ProcessingResultsPage /></ProtectedRoute>} />
      <Route path="/jobs" element={<ProtectedRoute><JobsPage /></ProtectedRoute>} />
      <Route path="/experiments" element={<ProtectedRoute><ExperimentsPage /></ProtectedRoute>} />
      <Route path="/experiment/:experimentId" element={<ProtectedRoute><ExperimentPage /></ProtectedRoute>} />
      <Route path="/experiment" element={<ProtectedRoute><ExperimentPage /></ProtectedRoute>} />

      {/* Groups */}
      <Route path="/groups" element={<ProtectedRoute><GroupsPage /></ProtectedRoute>} />
      <Route path="/groups/my" element={<ProtectedRoute><MyGroupsPage /></ProtectedRoute>} />
      <Route path="/groups/create" element={<ProtectedRoute><CreateGroupPage /></ProtectedRoute>} />
      <Route path="/groups/:groupId" element={<ProtectedRoute><GroupDetailPage /></ProtectedRoute>} />

      {/* Profile */}
      <Route path="/profile" element={<ProtectedRoute><UserProfilePage /></ProtectedRoute>} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
